export const EntityIdentifierEnums = {
    "IssueSummary": "Issue Summary",
    "MilestoneSummary": "Milestone Summary",
    "ProjectSummary": "Project Summary",
};
